/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AttributeModel from 'cio/models/attribute';
import EventModel from 'cio/models/event';
import EnvironmentService from 'cio/services/environment';
import { IdentifierKey } from 'cio/utils/identifiers';

interface DataIndexListRowArgs {
  item: AttributeModel | EventModel;
  type: string;
}

export default class DataIndexListRow extends Component<DataIndexListRowArgs> {
  @service environment!: EnvironmentService;

  // Workspaces created before multi-id workspaces were available have immutable cio_ids added when
  // people are created, but they're not an identifier. We need to show a tooltip to explain what
  // this mystery attribute is and what it's for.
  get isAutogenerated() {
    return (
      !this.environment.current.allEnabledIdentifiers.includes(IdentifierKey.CioId) &&
      this.args.item.id === IdentifierKey.CioId &&
      this.args.type === 'attribute'
    );
  }
}
